function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.22275,0,0,1.22275,-3.4901,-3.45088)"
}, React.createElement("path", {
  d: "M4.75,4.625C4.376,4.455 3.935,4.541 3.651,4.838C3.367,5.135 3.302,5.578 3.488,5.945L7.49,13.817C7.624,14.08 7.87,14.268 8.159,14.327C8.159,14.327 19.185,15.439 19.187,15.965C19.189,16.492 8.173,17.486 8.173,17.486C7.878,17.542 7.626,17.731 7.49,17.998L3.488,25.87C3.303,26.236 3.367,26.678 3.649,26.975C3.931,27.272 4.37,27.359 4.744,27.193L27.922,16.884C28.27,16.729 28.495,16.384 28.496,16.003C28.497,15.622 28.275,15.276 27.927,15.119L4.75,4.625Z"
}));
var SvgSubmitFilled = function SvgSubmitFilled(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSubmitFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/submit-filled.e5bb0365.svg";
export { ForwardRef as ReactComponent };